import env from '../environments';
import _ from 'lodash';
import RolesHelper from '../utils/RolesHelper';

const SIDEBAR_WRAPPER = 'md__sidebar__wrapper';
const getSidebarWrapper = () => document.getElementById(SIDEBAR_WRAPPER);

const voidLinkAction = e => {
  e.preventDefault();
};

const linkActionNewTarget = e => {
  e.preventDefault();
  window.open(e.target.getAttribute('data-url'), '_blank') ||
    window.location.replace(e.target.getAttribute('data-url'));
  return false;
};

const getProductsURL = () => {
  return `${env.services.payments.frontUrl}/account/products`;
};

const checkErrorServices = servicesConfig => {
  servicesConfig.map(serviceConfig => {
    if (!serviceConfig.rolId) {
      serviceConfig.rolId = RolesHelper.ROL_ADM_MDIRECTOR;
      serviceConfig.enable = true;
    }
    return serviceConfig;
  });
  return servicesConfig;
};

const checkGlobalService = service => {
  return (
    (service.rolId === RolesHelper.ROL_ADM_MDIRECTOR ||
      service.rolId === RolesHelper.ROL_ADM_MDIRECTOR_NEWFREE) &&
    !service.enableGlobalService
  );
};

const getCurrentServiceURL = service => {
  return env.services[service].frontUrl;
};

export {
  voidLinkAction,
  getProductsURL,
  linkActionNewTarget,
  checkErrorServices,
  checkGlobalService,
  getCurrentServiceURL,
  getSidebarWrapper,
};
